export const simpleArrayCompare = <T extends string>(a: T[], b: T[]): boolean => {
  if (a.length !== b.length) return false;

  const sortedA = a.sort();
  const sortedB = b.sort();

  for (let i = 0; i < sortedA.length; i += 1) {
    if (sortedA[i] !== sortedB[i]) return false;
  }
  return true;
};
